import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import { AppModule } from '@/store/Auth/AppModule';
import store from '@/store';
import InstitutionAccountSettings from '@/models/Accounts/InstitutionAccounts/Settings/InstitutionAccountSettings';
import UpdateInstitutionAccountSettingsRequest from '@/models/Accounts/InstitutionAccounts/Settings/UpdateInstitutionAccountSettingsRequest';

export interface IInstitutionAccountSettingsState {
    loading: boolean;
    loadingDialog: boolean;
    institutionalAccountSettings: InstitutionAccountSettings;
    institutionalAccountId: string;
}

@Module({ dynamic: true, store, name: 'InstitutionAccountSettingsModule', namespaced: true })
class InstitutionAccountSettingsStore extends VuexModule implements IInstitutionAccountSettingsState {

    public loading: boolean = true;
    public loadingDialog: boolean = false;
    public institutionalAccountSettings: InstitutionAccountSettings = new InstitutionAccountSettings();
    public institutionalAccountId: string = '';

    @Action
    async getInstitutionalAccountSettings(id: string) {

        this.setLoading(true);

        await ajax.get(`/portal-backend/fi-api/internal/institutional-accounts/${id}/settings`)
        .then(response => {
            this.context.commit("setInstitutionalAccountId", id);
            this.context.commit("setInstitutionalAccountSettings", response.data);
            this.setLoading(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoading(false);
        });
    }

    @Action
    async editInstitutionalAccountSettings(request: UpdateInstitutionAccountSettingsRequest) {

        this.setLoading(true);

        await ajax.patch(`/portal-backend/fi-api/internal/institutional-accounts/${this.institutionalAccountId}/settings`, request)
        .then(response => {
            this.context.commit("setInstitutionalAccountSettings", response.data);
            this.setLoading(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoading(false);
        });
    }

    @Action
    cleanState() {
        this.context.commit("resetState");
    }

    @Mutation
    resetState() {
        this.loading = true;
        this.loadingDialog = false;
        this.institutionalAccountSettings = new InstitutionAccountSettings();
        this.institutionalAccountId = '';
    }

    @Mutation
    private async setLoading(loading: boolean) {
        this.loading = loading;
    }

    @Mutation
    private async setLoadingDialog(loading: boolean) {
        this.loadingDialog = loading;
    }

    @Mutation
    private async setInstitutionalAccountSettings(response: InstitutionAccountSettings) {
        this.institutionalAccountSettings = response;
    }

    @Mutation
    private async setInstitutionalAccountId(id: string) {
        this.institutionalAccountId = id;
    }

}

export const InstitutionAccountSettingsModule = getModule(InstitutionAccountSettingsStore);